export const DEFAULT_CHAT_MODEL: string = "Normal";

export interface ChatModel {
  id: string;
  name: string;
  description: string;
}

export const chatModels: Array<ChatModel> = [
  {
    id: "Normal",
    name: "Xynth-V1",
    description: "For fast and accurate financial work",
  },
];
